module.exports = __webpack_public_path__ + "img/send-sel.2864d7d4.svg";